import { combineReducers } from 'redux';

import { connectRouter } from 'connected-react-router';
import app from './app/reducer';
import auth from './auth/reducer';
import homes from './homes/reducer';
import users from './users/reducer';
import meters from './meters/reducer';
import types from './deviceTypes/reducer';
import training from './training/reducer';
import devices from './devices/reducer';
import monitoring from './monitoring/reducer';
import reports from './reports/reducer';
import switches from './switch/reducer';

// Constants
import { CONSTANTS } from './auth/constants';

const appReducer = history =>
    combineReducers({
        app,
        auth,
        users,
        homes,
        meters,
        deviceTypes: types,
        training,
        devices,
        monitoring,
        reports,
        switches,
        router: connectRouter(history)
    });

const initialState = {};
export default history => (state, action) => {
    switch (action.type) {
        case CONSTANTS.ON_AUTH_LOGOUT:
            return appReducer(history)(initialState, action);

        default:
            return appReducer(history)(state, action);
    }
};
